// src/lib/render/figure-text.ts
//
// Marker for the visually hidden text equivalents that <Diagram> and
// <QuestionChart> render next to a figure (a graph's points, a chart's data
// table).
//
// That text sits inside the question stem's DOM, and passage highlights are
// stored as character offsets over the stem's text (highlight-dom.ts). Text a
// sighted student cannot see — and so can never select — must not count toward
// those offsets, or adding a description would shift every saved highlight
// placed after a figure. highlight-dom skips any subtree carrying this
// attribute.
export const FIGURE_TEXT_ATTR = 'data-figure-text'
export const FIGURE_TEXT_SELECTOR = `[${FIGURE_TEXT_ATTR}]`
